'use strict'

const fetch = require('node-fetch');
//const URLSearchParams = require('url').URLSearchParams
var FormData = require('form-data');
//var Canvas = require('canvas'), Image = Canvas.Image;
//var sharp = require('sharp');
var getPixels = require('get-pixels');
var exec = require('child_process').execSync;
var fs = require('fs');

var tf;
//check if we are running in browser.
if (typeof (document) === 'object') {
    tf = require('@tensorflow/tfjs');
} else {
    tf = require('@tensorflow/tfjs-node');
}

const Kmin_accuracy = 0.9;
var MIN_A = 0.9;
var model = null;
var itronModel = null;

exports.analyzeImage = async function (pixels, config, callback, debugImage) {
    try {
        var digits = config.digits.positions;
        MIN_A = config.digits.minAccuracy ? config.digits.minAccuracy : Kmin_accuracy;
        if (typeof document === 'object') {
            var width = pixels.shape[0];
            var height = pixels.shape[1];
            var channels = pixels.shape[2];
            let canvas = document.createElement('canvas');
            canvas.style.id = "targetCanvas";
            canvas.width = width;
            canvas.height = height;
            let ctx = canvas.getContext("2d");
            let sourceImageData = ctx.createImageData(width, height);
            let data = sourceImageData.data;
            for (var i = 0, len = width * height * channels; i < len; i++) {
                data[i] = pixels.data[i];
            }

            // draw original source to canvas
            ctx.putImageData(sourceImageData, 0, 0);
            for (var i = 0; i < digits.length; i++) {
                console.log("Analyzing digit: ", i);
                var digit = digits[i];
                let cordsWidth = digit.coords[2] - digit.coords[0];
                let cordsHeight = digit.coords[3] - digit.coords[1];
                //console.log("digit coords x:", digit.coords[0], " y:", digit.coords[1], " width:", cordsWidth, " height:", cordsHeight);
                let imgData = ctx.getImageData(digit.coords[0], digit.coords[1], cordsWidth, cordsHeight);
                if (digit.itronMode) await getItronDigit(i, digit, imgData, config.digits.min_accuracy);
                else await getDigit(i, digit, imgData, config.digits.min_accuracy);
                if (!callback) return { digits: digits };
                setTimeout(function () {
                    callback(null, { digits: digits });
                }, 1)
            }
        } else {// copy pixels to ImgData
            fs.readFile(config.file, async function (err, rotImg) {
                for (var i = 0; i < digits.length; i++) {
                    var digit = digits[i];
                    let cordsWidth = digit.coords[2] - digit.coords[0];
                    let cordsHeight = digit.coords[3] - digit.coords[1];
                    const tmpFile = '/lcp/filetransfer/digit' + i + '.jpg';
                    exec('convert ' + config.file + ' -crop ' + cordsWidth + 'x' + cordsHeight + '+' + digit.coords[0] + '+' + digit.coords[1] + ' ' + tmpFile);
                    var buf = fs.readFileSync(tmpFile);
                    if (digit.itronMode) await getItronDigit(i, digit, buf, config.digits.min_accuracy);
                    else await getDigit(i, digit, buf, config.digits.min_accuracy);
                    fs.unlinkSync(tmpFile);
                }
                if (!callback) return { digits: digits };
                setTimeout(function () {
                    callback(null, { digits: digits });
                }, 1)
            })
        }
    } catch (err) {
        console.log("ANALYZE ERROR:", err);
        if (!callback) return { digits: digits };
        setTimeout(function () {
            callback(null, { digits: digits });
        }, 1)
    }

}

function shapeMatch(a, b) {
    return Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index]);
}

async function getItronDigit(i, digit, imgData) {
    if (!itronModel) {
        await initializeItron();
    }
    if (!itronModel) {
        return digit;
    }
    //console.log("DEBUG:",imgData, typeof(imgData));
    tf.tidy(() => {
        try {
            let tensor;
            if (typeof (document) === 'object') {
                tensor = tf.browser.fromPixels(imgData);
            } else {
                tensor = tf.node.decodeImage(imgData);
            }
            let exp_tensor = tensor.resizeBilinear([80, 80])
                .toFloat()
                .expandDims();
            if (!shapeMatch(exp_tensor.shape, [1, 80, 80, 3])) {
                console.log("invalid itron tensor size detected:", exp_tensor.shape);
                return digit;
            }
            let predictions = itronModel.predict(exp_tensor);
            let values = predictions.dataSync();
            let val = values.indexOf(Math.max(...values));
            digit.result = val === 10 ? -1 : val;
            digit.reliability = values[val];
            //check minumum accuracy for valid value.
            let minAccuracy = digit.minAccuracy ? digit.minAccuracy : MIN_A;
            if (digit.reliability < minAccuracy) {
                digit.result = -1;
            }
        } catch (err) {
            console.log("getItronDigit error:", err);
            process.exit(1);
        }
    });
    tf.dispose();
    return digit;
}

async function initializeItron() {
    try {
        if (!itronModel) {
            if (typeof document === 'object') {
                itronModel = await tf.loadGraphModel('model/itron_web/model.json');
            }
            else {
                let handler = tf.io.fileSystem('/lcp/device/model/itron_web/model.json');
                itronModel = await tf.loadGraphModel(handler);
            }
        }
        console.log("Itron Model loaded successfully")
    } catch (err) {
        console.error("Itron Model failed to load:", err);
        //throw (err);
        process.exit(1);
    }
}


async function getDigit(i, digit, imgData) {
    //init model
    if (!model) {
        await initialize();
    }
    if (!model) {
        return digit;
    }
    tf.tidy(() => {
        try {
            let tensor;
            if (typeof (document) === 'object') {
                tensor = tf.browser.fromPixels(imgData);
            } else {
                tensor = tf.node.decodeImage(imgData);
            }
            let exp_tensor = tensor.resizeBilinear([80, 50])
                .toFloat()
                .expandDims();
            if (!shapeMatch(exp_tensor.shape, [1, 80, 50, 3])) {
                console.log("invalid tensor size detected:", exp_tensor.shape);
                return digit;
            }
            let predictions = model.predict(exp_tensor);
            let values = predictions.dataSync();
            let val = values.indexOf(Math.max(...values));
            digit.result = val === 10 ? -1 : val;
            digit.reliability = values[val];
            //check minumum accuracy for valid value.
            let minAccuracy = digit.minAccuracy ? digit.minAccuracy : MIN_A;
            if (digit.reliability < minAccuracy) {
                digit.result = -1;
            }
        } catch (err) {
            console.log("getDigit error:", err);
            process.exit(1);
        }
    });
    tf.dispose();
    return digit;
}

async function initialize() {
    try {
        if (!model) {
            if (typeof document === 'object') {
                model = await tf.loadGraphModel('model/active/model.json');
            } else {
                let handler = tf.io.fileSystem('/lcp/device/model/active/model.json');
                model = await tf.loadGraphModel(handler);
            }
        }
        console.log("Model loaded successfully")
    } catch (err) {
        console.error("Model failed to load:", err);
        //throw (err);
        process.exit(1);
    }
}



//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/digits/mlreader2.js
// module id = 845
// module chunks = 0